import React, { FC } from 'react';
import { PriceSimulatorV3Context } from './PriceSimulatorV3Context';

type Props = {
    children: React.ReactNode;
};

const PriceSimulatorV3ContextWrapper: FC<Props> = ({ children }) => {
    return <PriceSimulatorV3Context>{children}</PriceSimulatorV3Context>;
};

export { PriceSimulatorV3ContextWrapper };
